import React, { useState, useContext, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import StepperNavigationButtons from "../../StepperNavigationButtons/StepperNavigationButtons";
import { EWContext } from "../../../context/EWContext";
import FormBuilder from "../FormBuilder/FormBuilder";
import styles from "./AccountVerificationForm.module.css";
import { CCVServiceValidation, CCVServiceValidationV2 } from "../../../services/validations/CCVService";
import { recaptchaServiceValidation } from "../../../services/validations/recaptchaService";
import { addressValidation } from "../../../services/validations/addressService";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import {
  getFormAnswers,
  arrayFieldsToObject,
  getEligibilityQuestions,
  findElementIntoArray
} from "../../../utils/utils";
import {
  verifyCaptchaService,
  verifyUtillityAccountService,
  addressSelectionService,
} from "../../../services/services";
import { CUSTOMER_GROUPS } from "../../../constants";

function AccountVerificationForm(props) {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [accountState, setAccountState] = useContext(
    EWContext
  );

  const {
    baseUrl,
    version,
    recaptcha,
    questions: {
      validate: questions
    },
    answers: {
      validate: answers
    },
    customer,
    folderImages,
    customErrors,
    verifyUtilityAccount,
    verifyUserAccount,
    previousCustomerInformation,
    pimcore,
    storeContact,
    behaviors,
    conditionSpecificBehaviors,
    productInfo,
  } = accountState;

  let isRequired = false;

  const accountDetailsAnswers = useState(previousCustomerInformation.length > 0
    ? questions.map(question => {
      const newAnswer = {
        "id": "termsAndConditions",
        "label": "Terms and Conditions",
        "name": "termsAndConditions",
        "group": "validate",
        "position": 9,
        "type": "tandc",
        "required": true,
        "value": true,
        "textValue": true,
        "extraValues": [],
        "showOnSummary": false,
        "summaryLabel": "",
        "maskType": "",
        "multiple": false,
        "open": false,
        "descriptionSkedulo": false
      }
      return { ...findElementIntoArray(previousCustomerInformation, "id", `${question.id}`) || newAnswer };
    }) : [])[0];

  /*
   * Specifies if the customer is a Trade Ally and if there is previous information
   * saved from a previous EW process (i.e another product from a previous EW in the cart)
   * @type {boolean}
  */
  const isTradeAlly = customer.groupName === CUSTOMER_GROUPS.tradeAlly;
  const tradeAllyData = useState(isTradeAlly && accountDetailsAnswers.length > 0)[0];
  const newAnswers = answers ? answers : [];
  const validateAnswers = isTradeAlly ? accountDetailsAnswers : newAnswers;

  const [loading, setLoading] = useState(false);
  const [captchaError, setCaptchaError] = useState(false);
  const [errorFields, setErrorFields] = useState(true);
  const [isValidAddress, setIsValidAddress] = useState(false);
  const [isValidRecaptcha, setIsValidRecaptcha] = useState(false);
  const [isValidUtilityAccount, setIsValidUtilityAccount] = useState(false);
  const [userInfoFormAnswers, setUserInfoFormAnswers] = useState(validateAnswers);
  const [customerValidation, setCustomerValidation] = useState([]);
  const [formAnswers, setFormAnswers] = useState(() =>
    arrayFieldsToObject(questions, "id", validateAnswers)
  );
  const [errorInForm, setErrorInForm] = useState({
    message: customErrors.genericError,
    genericMessage: customErrors.contactError,
    labelButton: "Back",
    error: false
  });
  const formBehaviors = useState(behaviors)[0];
  const [disableState, setDisableState] = useState({});
  const { handleNext, handleBack, group } = props;
  let questions1 = [];
  const [question2, setquestion2] = useState(questions);
  const enabledFields = conditionSpecificBehaviors?.crEnableAccountCheck
    ? conditionSpecificBehaviors?.crEnableAccount
    : ["phoneNumber", "emailAddress", "hearAboutUs", "type_of_residence", "thermostat_type"];
  const coordinatesField = ["address"];
  const [addressCoordinates, setAddressCoordinates] = useState({});
  const [unitLength, setUnitLength] = useState(0);
  const {
    numberOfPeopleBasedIncome,
    cr_income_Household,
    income_label_prefix,
    income_label_suffix,
    peopleBasedValueDropdownValue,
    household_income_value,
    crhousehold_income_primary_message,
    crhousehold_income_secondary_message,
    cr_income_based_condition
    } = conditionSpecificBehaviors ? conditionSpecificBehaviors : false;

  useEffect(() => {
    if (tradeAllyData) {
      accountDetailsAnswers.forEach(answer => {
        setDisableState(prevState => { return { ...prevState, [answer.id]: true } })
      })
    } else {
      validateAnswers.map(answer => {
        return enabledFields.includes(answer.id)
          ? setDisableState(prevState => { return { ...prevState, [answer.id]: false } })
          : setDisableState(prevState => { return { ...prevState, [answer.id]: formBehaviors?.disable_customer_fields || false } });
      });
    }
    getUnitNumber(userInfoFormAnswers);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (validateAnswers.length > 0) {
      const formIsAnswered = validateAnswers.every((field) => {
        if(field.type === "date") {
          console.log(field);
          if(field.value == "Invalid Date") {
            return false
          }
          let dateRange =  questions.find(ques => ques.id === field.id).field.rangeDates;
          
          if(dateRange?.minDate?.date) {

            if(new Date(field.value ) < new Date(dateRange.minDate.date)){
              return false
            }
          } 

          if(dateRange?.maxDate?.date) {
            if(new Date(field.value) > new Date(dateRange.maxDate.date)) {
              return false
            }
          }
        }
        return field ? (field.required ? field.value !== "" : true) : false
      });

      if (formIsAnswered) {
        setUserInfoFormAnswers(validateAnswers);
        setErrorFields(false);
      } else {
        setErrorFields(true);
      }
    } else {
      setErrorFields(true);
    }
  }, [validateAnswers]);

  useEffect(() => {
    if (isValidAddress && isValidRecaptcha && isValidUtilityAccount) {
      // Saving answers in the App state
      userInfoFormAnswers.forEach(answer => {
        if (coordinatesField.includes(answer.id)) answer.extraValues = { ...addressCoordinates };
      });
      setAccountState((prevAccountState) => ({
        ...prevAccountState,
        answers: {
          ...prevAccountState.answers,
          validate: [...userInfoFormAnswers]
        },
        submitAttempts: 0,
        recaptchaVerification: isValidRecaptcha,
        addressVerification: isValidAddress,
        accountVerificationUtility: isValidUtilityAccount,
        customerValidation,
        eligibilityQuestions: [
          ...getEligibilityQuestions(customerValidation, prevAccountState.eligibilityQuestions)
        ],
      }));
      setLoading(false);
      handleNext(true);
    }
  }, [
    isValidAddress,
    isValidRecaptcha,
    isValidUtilityAccount,
    userInfoFormAnswers,
    setAccountState,
    handleNext,
    customerValidation,
    addressCoordinates,
    coordinatesField
  ]);

  useEffect(() => {
    if (errorInForm.error) {
      setAccountState((prevAccountState) => ({
        ...prevAccountState,
        ...{
          submitAttempts: prevAccountState.submitAttempts + 1,
          eligibilityError: errorInForm,
        },
      }));
    }
  }, [errorInForm, setAccountState]);

  /**Alerting the questions when first time page is loading */
  useEffect(() => {
    questions.forEach((item) => {
      if (item.contractorShow === true) {
        questions1.push(item);
        setquestion2(questions1)
      }
    })
    // eslint-disable-next-line
  }, []);

  const getUnitNumber = (formInputs) => {
    // eslint-disable-next-line
    formInputs.map(data => {
      if (data.id === 'unit' && data?.value?.length > 0) {
        setUnitLength(data?.value?.length);
      } else if (data.id === 'unit' && data?.value?.length === 0) {
        setUnitLength(0);
      }
    });
  }

     /**On the base of number of people changing the Income Range */
     const numberOfPeopleBasedIncomeLabelChange= (answers) => {
      numberOfPeopleBasedIncome.forEach((dropdownValue) => {
        if(answers?.numberofpeople.textValue === dropdownValue?.key){
          questions.forEach((peopleBasedIncome) => {
            if(peopleBasedIncome.id === cr_income_Household){
              peopleBasedIncome['label']=`${income_label_prefix} ${dropdownValue.value} ${income_label_suffix}`;
            }})
            setquestion2(questions)
          }
      })
    }

  const handleOnFormAnswered = (answers) => {
    peopleBasedValueDropdownValue && numberOfPeopleBasedIncomeLabelChange(answers);
    setFormAnswers(answers);
    let modifiedAnswers = [];

    /**With Unique condition On the based of dropdown selection modified the question */
    if (conditionSpecificBehaviors?.cr_hear_about) {
      conditionSpecificBehaviors.drop_down_value.forEach((dropdownSelection) => {
        if (answers?.hearAboutUs?.value === dropdownSelection) {
          questions1 = []
          questions.forEach((item) => {
            if (item.contractorShow === true) {
              modifiedAnswers.push(item.id)
              questions1.push(item);
              setquestion2(questions1)
            }
          })
        }
      })
      if (answers?.hearAboutUs?.value === conditionSpecificBehaviors?.cr_dropdown_selected_value) {
        setquestion2(questions)
      }
    }
    const userInfoFormAnswers = getFormAnswers(answers, question2);
    setUserInfoFormAnswers(userInfoFormAnswers);
    getUnitNumber(userInfoFormAnswers);
    conditionSpecificBehaviors?.cr_summit_utilities && setRequiredFields(userInfoFormAnswers);
    const formIsAnswered = getFormAnswers(answers, question2).every(
      (field) => {
        return field.required ? field.value !== "" : true;
      }
    );
    if (formIsAnswered) {
      setErrorFields(false);
      const userInfoFormAnswers = getFormAnswers(answers, question2);
      setUserInfoFormAnswers(userInfoFormAnswers);
      setAccountState((prevAccountState) => ({
        ...prevAccountState,
        answers: {
          ...prevAccountState.answers,
          validate: [...userInfoFormAnswers]
        },
      }));
    } else {
      setErrorFields(true);
    }
  };

  const displayError = (primaryErrorMessage, secondaryErrorMessage, customError) => {
    const errorMessage = primaryErrorMessage?.message || primaryErrorMessage;
    setLoading(false);
    if (captchaError) return;
    primaryErrorMessage && primaryErrorMessage?.captchaError && setCaptchaError(true);
    if (primaryErrorMessage && !primaryErrorMessage?.captchaError) {
      setErrorInForm(prev => {
        return {
          ...prev,
          ...{
            message: errorMessage || customError,
            genericMessage: secondaryErrorMessage || '',
            error: true
          }
        }
      })
    }
  };

  const recaptchaAPICall = async () => {
    if (recaptcha.enable) {
      // Recaptcha validation
      if (!executeRecaptcha) {
        setCaptchaError(true);
        throw new Error("Google reCaptcha error");
      }
      const token = await executeRecaptcha("submit");
      const verifyCaptchaResponse = await verifyCaptchaService(
        token,
        recaptcha
      );
      const recaptchaValidation = await recaptchaServiceValidation(verifyCaptchaResponse);

      if (recaptchaValidation.isValid) {
        setIsValidRecaptcha(true);
        setCaptchaError(false);
      } else {
        setIsValidRecaptcha(false);
        setCaptchaError(true);
      }
    } else {
      setIsValidRecaptcha(true);
      setCaptchaError(false);
    }
  }

  const addressAPICall = async () => {
      // Checking address
      const addressResponse = await addressSelectionService(
          baseUrl,
          formAnswers
      );

      const { disable_smarty_validation } = formBehaviors;
      const { latitude, longitude } = addressResponse[0].metadata;
      const addressMgData = {
          addressResponse,
          storeContact,
          customErrors,
          disable_smarty_validation,
      };
      const addressMgValidation = await addressValidation(addressMgData);

      if (addressMgValidation.isValid && disable_smarty_validation) {
          setIsValidAddress(true);
          return addressMgValidation.addressBarcode;
      } else if (addressMgValidation.isValid && !disable_smarty_validation) {
          if (productInfo.appointmentJobType !== "" && latitude && longitude) {
              setIsValidAddress(true);
              setAddressCoordinates((prevState) => ({
                  ...prevState,
                  latitude,
                  longitude,
              }));
              return addressMgValidation.addressBarcode;
          } else if (productInfo.appointmentJobType === "") {
              setIsValidAddress(true);
              setAddressCoordinates({});
              return addressMgValidation.addressBarcode;
          } else {
              setIsValidUtilityAccount(false);
              setAddressCoordinates({});
              displayError(customErrors.smartystreetsError);
          }
      } else {
          setIsValidUtilityAccount(false);
          setAddressCoordinates({});
          displayError(
              addressMgValidation.error.message1,
              addressMgValidation.error.message2,
              customErrors.smartystreetsError
          );
      }
  };

  const ccvAPICall = async (addressBarcode) => {
    // Checking user account in CCV service
    let utilityAccountResponse = null;
    utilityAccountResponse = await verifyUtillityAccountService(
      formAnswers,
      verifyUtilityAccount,
      addressBarcode,
      customErrors.genericError,
      baseUrl
    );
    if (!utilityAccountResponse) displayError(customErrors.accountVerifyError);
    const utillityAccountData = utilityAccountResponse;
    const CCVData = {
      utillityAccountData,
      measureId: pimcore.measureId,
      measureClassId: pimcore.measureClassId,
      verifyUserAccount,
      storeContact,
      customErrors,
      productInfo
    };
    let CCVValidation = {};
    // Checking for version configuration
    if (version && (version === 2 || version === "2")) {
      CCVValidation = await CCVServiceValidationV2(CCVData);
    } else {
      CCVValidation = await CCVServiceValidation(CCVData);
    }
    if (CCVValidation.isValid) {
      setCustomerValidation(utillityAccountData);
      setIsValidUtilityAccount(true);
    } else {
      setIsValidUtilityAccount(false);
      displayError(
        CCVValidation.error.message1,
        CCVValidation.error.message2,
        customErrors.accountVerifyError
      );
    }
  };

  /**function for taking the id on the basis of selection */
  const questioncheck = (data) => validateAnswers.find(answer => answer.id === data)
    ? validateAnswers.find(answer => answer.id === data).value
    : ''

  /**function for restricting the user and showing the error message on the basis of Heat and Cool System type */
  const checkCoolingHeatingType = () => {
    if ((questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_air_pump || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_air_pump)
      && (questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_ductless_pump || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_ductless_pump)
      && (questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_ground_pump || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_ground_pump)
      && (questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_ele_baseboards || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_central_ac)
      && (questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_ele_furnace || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_central_ac)
      && (questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_gas_boiler || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_central_ac)
      && (questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_gas_furnace || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_central_ac)
      && (questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_ele_baseboards || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_other)
      && (questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_ele_furnace || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_other)
      && (questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_gas_boiler || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_other)
      && (questioncheck("heat_system_type") !== conditionSpecificBehaviors?.cr_gas_furnace || questioncheck("cooling_system_type") !== conditionSpecificBehaviors?.cr_other)) {
      displayError(conditionSpecificBehaviors.crCoolingHeatingErrorMessage);
    }
  }

   /**function for restricting the user and showing the error message on the basis of Income qualification */
   const crHouseholdCheck = () => {
    if (questioncheck(cr_income_Household) === household_income_value){
      displayError(crhousehold_income_primary_message,crhousehold_income_secondary_message);
    }
  }

  /* Adding Validation Message. */
  const setMandatoryFieldMessages = (question) => {
    const validationMessage = "required";
    const errorMessage = "This field is required";
    question.field.validators.push(validationMessage);
    question.field.errorMessages.push(errorMessage);
  }

/*When user selects Home as user type. */
  const userTypeHomeSelection = (question) => {
    if (question?.id === conditionSpecificBehaviors?.cr_companyId) {
      question.required = false;
      question.field.validators = [];
      question.field.errorMessages = [];
    }
    if (question?.id === conditionSpecificBehaviors?.cr_firstNameId || question?.id === conditionSpecificBehaviors?.cr_lastNameId) {
      question.required = true;
      setMandatoryFieldMessages(question);
    }
  }

/*When user selects Business as user type. */
  const userTypeBusinessSelection = (question) => {
    if (question?.id === conditionSpecificBehaviors?.cr_firstNameId || question?.id === conditionSpecificBehaviors?.cr_lastNameId) {
      question.required = false;
      question.field.validators = [];
      question.field.errorMessages = [];
    }
    if (question?.id === conditionSpecificBehaviors?.cr_companyId) {
      question.required = true;
      setMandatoryFieldMessages(question);
    }
  }

  /*On the basis of user selection from userType updating the mandatory/non-mandatory fields. */
  const setRequiredFields = (userInputs) => {
    userInputs.forEach((userData) => {
      if (userData?.id === conditionSpecificBehaviors?.cr_TypeOfUserEntityType && userData?.value === conditionSpecificBehaviors?.cr_userTypeHome) {
        isRequired = true;
      } else if (userData.id === conditionSpecificBehaviors?.cr_TypeOfUserEntityType && userData?.value === conditionSpecificBehaviors?.cr_userTypeBusiness) {
        isRequired = false;
      }
    });
    questions.forEach((question) => {
      isRequired ? userTypeHomeSelection(question) : userTypeBusinessSelection(question);
      });
    }

  const handleSubmit = async (evt) => {
    setLoading(true);
    setCaptchaError(false);
    evt.preventDefault();
    try {
      if (conditionSpecificBehaviors?.cr_summary_message) {
        validateAnswers.forEach((resp) => {
          if (resp?.id === 'state' && resp?.value !== 'NJ') {
            let errorInForm = {
              message: 'Rebates are unavailable in states other than NJ',
              genericMessage: '',
              error: true
            }
            setAccountState((prevAccountState) => ({
              ...prevAccountState,
              ...{
                eligibilityError: errorInForm,
              },
            }));
          }
        })
      }
      if (conditionSpecificBehaviors?.cr_cooling_system_type_check) {
        checkCoolingHeatingType()
      }
      cr_income_based_condition && crHouseholdCheck();
      await recaptchaAPICall();
      const addressBarcode = await addressAPICall();
      if (!(formBehaviors?.disable_ccv_service)) {
        await ccvAPICall(addressBarcode);
      } else {
        setIsValidUtilityAccount(true);
      }
    } catch (error) {
      displayError(error);
    }
  };

return (
  <FormBuilder
    questions={question2}
    answers={userInfoFormAnswers}
    onFormAnswered={handleOnFormAnswered}
    handleSubmit={handleSubmit}
    formInstructions={group.instructions}
    extraInfoAfterRequired={group.extraInfoAfterRequired}
    requiredFieldsSubtitule={true}
    customConfig={{
      disableFields: disableState
    }}
    unitValue={unitLength}
  >
    {
      captchaError ? (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <p
            className={
              styles.recaptcha +
              " MuiFormHelperText-root Mui-error"
            }
          >
            <img
              alt="recaptcha"
              src={folderImages + "/reCAPTCHA_Error.svg"}
            />

            <Typography variant="caption" gutterBottom>
              Uh-oh, there's is an error with your form
              validation. Please try again
            </Typography>
          </p>
        </Grid>
      ) : null}
    <StepperNavigationButtons
      handleBack={handleBack}
      handleNext={() => null}
      loading={loading}
      nextButtonDisabled={errorFields}
    />
  </FormBuilder>
);
}

export default withErrorHandler(AccountVerificationForm);
